<template>
  <subscription-layout>
    <v-layout>
      <v-container fill-height grid-list-xl w--max--800>
        <v-layout row wrap>
          <v-flex xs12>
            <app-name-page name="My Membership"></app-name-page>
          </v-flex>
          <v-flex xs12 v-if="last_plan">
            <h2 class="_title text-xs-center">My Current Membership</h2>
            <div class="_status-box">
              <p class="font--medium">
                <app-svg-icon name="ui/NG_TICK"></app-svg-icon>
                You are currently a paid member on the
                <span v-if="$auth.user().subscription.method == 'subscription'">{{ ($auth.user().plan() ||
                  {}).invoice_period }} month plan</span>
                <span v-if="$auth.user().subscription.method == 'recurring'">Smart Status</span>
              </p>
              <p class="font--medium" v-if="cancel_subscription">
                <app-svg-icon name="ui/NG_TICK"></app-svg-icon>
                You are currently paid up to and including
                <span v-if="$auth.user().subscription">{{ $auth.user().subscription.ends_at }}</span>
              </p>

              <p class="font--medium" v-if="!cancel_subscription">
              <app-svg-icon name="ui/NG_TICK"></app-svg-icon>
              <!-- <p class="font--medium"> -->
                You have successfully cancelled your paid membership and will not be able to access the NannyGranny
                database after
                <span v-if="$auth.user().subscription">{{ $auth.user().subscription.ends_at }}</span>
                <!-- </p> -->
              </p>

              <div class="btn" v-if="cancel_subscription">
                <div v-if="$auth.user().subscription.method === 'subscription'">
                  At the end of the 3 month plan, your membership will roll onto our Smart Status.
                  If you wish to cancel your monthly membership at any time, click
                  <span class="cancelsubs" @click="cancelrecurring">here</span>.
                </div>
                <div v-if="$auth.user().subscription.method === 'recurring'">
                  If you wish to cancel your monthly membership at any time, click
                  <span class="cancelsubs" @click="cancelrecurring">here</span>.
                </div>

                <!-- 🚨 New prominent cancel button -->
                <button class="cancel-membership-btn" @click="cancelrecurring">
                  Cancel my Membership
                </button>
              </div>


              <p class="font--medium" v-if="recurring_plan_information_additional">
                <app-svg-icon name="ui/NG_TICK"></app-svg-icon>
                {{ recurring_plan_information_additional }}
              </p>

            </div>
          </v-flex>


          <v-flex xs12 text-xs-center v-if="show_monthly_subsr">
            <h2 class="_title" style="margin-bottom:20px;">Signup to monthly NannyGranny Membership</h2>
            <i class="textinstruct">*All Memberships are automatically renewed until cancelled. Once monthly membership lapses, user must re-pay the Registration fee before rolling back onto the Smart Status plan.</i>
            <v-btn color="primary" v-if="last_plan" class="elevation-0 v-btn--default">
              <div @click="recurringmethod">Start Membership</div>
            </v-btn>
          </v-flex>

          <v-flex xs12 text-xs-center v-if="check_card_added">
            <h2 class="_title">Payment</h2>
            <div v-if="check_card_added">
              <p><b>Your Saved Card Details</b></p>
              <span id="cardnumber">Loading Card Details....</span><span id="cardexpiry"></span>
            </div>
            <v-btn v-if="check_card_added" color="primary" class="elevation-0 v-btn--default updatecardbtn">
              <div @click="updatecarddetails">Update Card</div>
            </v-btn>
            <v-btn v-else color="primary" class="elevation-0 v-btn--default">
              <div @click="updatecarddetails">Add Card</div>
            </v-btn>
          </v-flex>


          <v-flex xs12 text-xs-center v-if="show_plans">
            <h2 class="_title" v-if="new_customer">Unlock full access today</h2>
            <h2 class="_title" v-else>Change/renew subscription</h2>
            <AppBtnTogglePlanReg @clicked_plan="renewsubscription_cardsave($event)" :showvalidplans="signupplans"
              class="_plan" v-model="invoice.plan_id"></AppBtnTogglePlanReg>
            <!--<v-btn color="primary"
                             @click="renewsubscription"
                             class="elevation-0 v-btn--default"><div v-if="new_customer">Signup Now</div> <div v-else>Renew subscription</div></v-btn>-->
            <!-- <v-btn color="primary" outline class="v-btn&#45;&#45;default">Cancel subscription</v-btn>-->
          </v-flex>


          <v-flex xs12 class="_invoice-box">
            <h2 class="_title text-xs-center">Invoice history</h2>
            <subscription-invoice-table :key="invoice_table_reload"></subscription-invoice-table>
          </v-flex>
          <v-dialog v-model="modal" :fullscreen="$vuetify.breakpoint.xsOnly" max-width="750">

            <v-card flat class="py-5">
              <v-card-text class="pb-0">
                <h2 v-if="show_submit_button" style="text-align:center">{{ modaltitle }}</h2>
                <v-container grid-list-xl class="pb-0">
                  <div id='cardloadedimg' style="text-align: center;"><img class="image-how-it-work"
                      src="@/assets/img/in-turn-rotation.gif" /></div>
                  <div id='cardData' style="text-align: center;"></div>
                </v-container>
              </v-card-text>
              <div v-if="show_monthly_subsr" class="alertnotification" style="text-align:center">
                <p><i>Notification : CVV is not required to complete this transaction</i></p>
              </div>
              <v-card-actions>
                <v-btn v-if="show_submit_button" depressed :loading="loading" @click="purchase"
                  class="primary ma-auto">{{ buttonlabel }}</v-btn>
              </v-card-actions>

            </v-card>
          </v-dialog>
        </v-layout>
      </v-container>
    </v-layout>
  </subscription-layout>
</template>


<script>
import AppBtnTogglePlanReg from '@/components/app-buttons/app-btn-toggle-plan-reg-sub.vue'
import SubscriptionInvoiceTable from './subscription-invoice-table'
import AppNamePage from '@/components/app-name-page'
import SubscriptionLayout from './subscription-layout'
import AppFormPaymentCreditCard from '../../../components/app-form/app-form-payment-credit-card'
import InvoiceClass from '../../../models/InvoiceClass'
import Parent from '../../../models/user/ParentClass'
import { MW_MERCHANT_UUID, MW_API_KEY, MW_TEST_MODE, MAIN_SIGNUP_PLANS_OPT } from '../../../config/constants'
import moment from 'moment'

// global register

export default {
  name: 'subscription',

  components: { AppFormPaymentCreditCard, SubscriptionLayout, AppNamePage, SubscriptionInvoiceTable, AppBtnTogglePlanReg },

  data() {
    return {
      loading: false,
      modal: false,
      last_plan: false,
      new_customer: true,
      invoice: new InvoiceClass(),
      summ: 0,
      invoice_table_reload: 0,
      mwPayframe: null,
      show_submit_button: true,
      is_recurring: false,
      show_monthly_subsr: false,
      check_card_added: false,
      show_plans: false,
      carddetails: null,
      buttonlabel: "Purchase",
      modaltitle: "Credit Card Details",
      recurring_plan_information_additional: null,
      cancel_subscription: false,
      signupplans: MAIN_SIGNUP_PLANS_OPT,
    }
  },

  mounted() {
    if (this.invoice.plan_id > 0) {
      this.last_plan = true;
    }
    if (this.$auth.user().subscription.method == 'recurring') {
      this.is_recurring = true;
    }
    if (this.$auth.user().subscription.cancel_subscription == true) {
      this.cancel_subscription = true;
    }
    if (this.$auth.user().subscription.is_new == false) {
      this.new_customer = false;
    }
    if (this.$auth.user().subscription.show_monthly_subsr == true) {
      this.show_monthly_subsr = true;
    }
    if (this.$auth.user().subscription.show_plans == true) {
      this.show_plans = true;
    }
    if (this.$auth.user().subscription.recurring_plan_information_additional !== null && this.$auth.user().subscription.recurring_plan_information_additional.trim().length > 0) {
      this.recurring_plan_information_additional = 'You have subscribed to the Monthly plan which will commence from  ' + this.$auth.user().subscription.recurring_plan_information_additional;
    }
    if (this.$auth.user().user_card_token !== null && this.$auth.user().user_card_token.trim().length > 0) {
      this.check_card_added = true;
      const data = {
        card_id: this.$auth.user().user_card_token
      }
      // document.getElementById("carddetails").innerText =  "Loading Card Details...."; 
      this.$store.dispatch('subscription/payments/GET_CARD_DETAILS', data).then((data) => {
        if (data.cardID) {
          this.$auth.user(new Parent(data));
          var cardlast = data.cardNumberLast;
          var cardExpiryMonth = data.cardExpiryMonth;
          var cardExpiryYear = data.cardExpiryYear;
          this.carddetails = 'xxxx-xxxx-xxxx-' + cardlast;
          // alert(cardlast);
          document.getElementById("cardnumber").innerHTML = this.carddetails;
          document.getElementById("cardexpiry").innerHTML = cardExpiryMonth + '/' + cardExpiryYear;
        } else {
          this.showSnackBar('Technical issue fetching the card details....please wait...', 'error')
        }

      })


    }



  },

  computed: {
    currentPlan() {
      return this.$store.getters['subscription/selectedPlan']
    }
  },
  watch: {

    currentPlan(plan) {
      let price = this.$lodash.get(plan, 'price_all', 0)
      this.summ = (price === 0 ? this.$lodash.get(plan, 'price', 0) : price)
    }
  },
  created() {
    this.invoice.plan_id = (this.$auth.user().plan() || {}).id
    let plans1 = this.$store.getters['subscription/plans']
    var planCreatures = plans1.filter(function (creature) {
      return creature.invoice_period == 1;
    });
    this.monthlyplanid = planCreatures[0].id;
    this.monthlyplansum = planCreatures[0].price;
  },
  methods: {
    submitplan(plan_id) {
      // alert("test"+plan_id);
    },
    purchase() {
      this.loading = true
      const button = document.querySelector('button');
      const buttonText = button.textContent;
      if (buttonText == 'Yes') {
        const data = {
          plan_id: this.invoice.plan_id,
        }
        this.$store.dispatch('subscription/payments/CANCEL_MONTHLY_SUBS', data).then((data) => {
          this.$auth.user(new Parent(data))

          this.showSnackBar('You have successfully cancelled your NannyGranny membership.', 'success')
          // this.$toast && this.$toast.success
          //   ? this.$toast.success('You have successfully cancelled your NannyGranny membership.')
          //   : alert('You have successfully cancelled your NannyGranny membership.');
          this.$router.go()
        });
      } else {

        mwPayframe.submitPayframe(this)
      }
    },
    cancelrecurring() {
      this.modal = true;
      this.modaltitle = "Cancel Membership?";
      this.show_submit_button = true;
      this.loading = false
      this.buttonlabel = "Yes";
      var cardloadedimg = document.getElementById("cardloadedimg");
      cardloadedimg.style.display = 'none';
      document.getElementById("cardData").innerHTML = "Are you sure you want to cancel monthly membership?";

    },
    recurringmethod() {
      var cardloadedimg = document.getElementById("cardloadedimg");
      cardloadedimg.style.display = 'block';
      this.modal = true;
      this.show_submit_button = false;
      const data = {
        plan_id: this.monthlyplanid,
        summ: this.monthlyplansum,
      }
      document.getElementById("cardData").innerHTML = "";

      var button = document.getElementById("submitButton");
      let payframeScript = document.createElement('script');
      payframeScript.setAttribute('src', MW_TEST_MODE ? 'https://securetest.merchantwarrior.com/payframe/payframe.js' : 'https://secure.merchantwarrior.com/payframe/payframe.js');
      document.head.appendChild(payframeScript);
      this.$store.dispatch('subscription/payments/ACCESS_TOKEN', data).then((data) => {
        this.$auth.user(new Parent(data))
        add_card_dialog(data.access_token);
        //this.show_submit_button = true;
      });

      var add_card_dialog = (access_token) => {
        let checkInterval = setInterval(function () {
          let payframeScriptIsReady = false;
          if (typeof payframe !== 'undefined') {
            payframeScriptIsReady = true;
            clearInterval(checkInterval);
            setShowSubmitButton(false);
            var method = 'addCard'; // change this to getPayframeToken for payment payframe
            var threeDS = true; // this will only work with the getPayframeToken method
            var style = {
              fontFamily: 'Open Sans, sans-serif',
              fontSrc: ['https://fonts.googleapis.com/css?family=Open+Sans'],
            };
            // var accessToken = access_token;

            var accessToken = access_token;
            // alert(access_token);

            var submitURL = MW_TEST_MODE ? 'https://base.merchantwarrior.com/payframe/' : 'https://api.merchantwarrior.com/payframe/';

            var payframeObject = {
              accessToken: accessToken,
              payframeDivId: 'cardData',
              src: MW_TEST_MODE ? 'https://securetest.merchantwarrior.com/payframe/' : 'https://secure.merchantwarrior.com/payframe/',
              submitUrl: submitURL,
              style: style,
              method: method,
            };
            this.mwPayframe = new payframe(payframeObject);
            this.mwPayframe.deploy();
            mwPayframe.mwCallback = function () {
              // alert('1');
              //Example of success and error scenarios below
              if (threeDS) {
                //alert('1');
                processResponseEvent_recurring(method, arguments, tdsCheck);
              } else {
                //alert('2');
                processResponseEvent_recurring(method, arguments);
              }
            };



            this.mwPayframe.loading = function () {
              var mwIframe = document.getElementById("mwIframe");
              var cardDiv = document.getElementById("cardData");
              //alert();
              setShowSubmitButton(false);
              // Hide the payframe during load operations
              mwIframe.style.visibility = 'hidden';

              // Assign the parent div the same dimensions as the payframe
              var height = mwIframe.height;
              var width = mwIframe.width;

              cardDiv.style.height = height;
              cardDiv.style.width = width;

              // Place a loading animation in the center of the payframe
              cardDiv.style.background = "url('https://securetest.merchantwarrior.com/inc/image/loading_gif.gif') center center no-repeat";
            };

            this.mwPayframe.loaded = function () {
              //button.style.visibility = "visible";
              var mwIframe = document.getElementById("mwIframe");
              //alert('loaded');

              var cardDiv = document.getElementById("cardData");
              var cardloadedimg = document.getElementById("cardloadedimg");
              // Remove the loading animation after the payframe has completed its operations and display the payframe
              cardDiv.style.visibility = 'none';
              cardloadedimg.style.display = 'none';
              if (mwIframe) {
                mwIframe.style.visibility = 'visible';
                setShowSubmitButton(true);
                console.log('Loaded');
                //alert('loaded');
              }
            }
          }
        }, 500);
        var setShowSubmitButton = (value) => {
          this.show_submit_button = value;
        }
        var processResponseEvent_recurring = (method, responseapi, tdsCheck) => {
          var responseCode = mwPayframe.responseCode;
          var responseMessage = mwPayframe.responseMessage;

          if (method == 'addCard') {
            var cardID = responseapi[0];
            var payframeToken = responseapi[1];
            var payframeKey = responseapi[2];
            console.log(responseapi);
            if (cardID && cardID != 'NO_TOKEN') {
              const data = {
                card_id: cardID,
                plan_id: this.monthlyplanid,
                summ: this.monthlyplansum,
              }


              this.$store.dispatch('subscription/payments/RECURRING_CARD', data).then((data) => {
                if (data.user_card_token) {
                  //this.$auth.user(new Parent(data))
                  this.modal = false
                  this.loading = false
                  this.showSnackBar('You are successfully subscribed to Smart Membership', 'success')
                  //this.invoice_table_reload++
                  this.show_monthly_subsr = false;
                  setTimeout(
                    this.$router.go()
                    , 10000);
                  //this.recurring_plan_information_additional='You have subscribed to the Monthly plan which will commence from '+moment(this.$auth.user().subscription.ends_at).format('DD/MM/YYYY');
                } else {
                  this.showSnackBar(data.message, 'error')
                  this.loading = false
                }

                setLoading(false);
                mwPayframe.reset();
                mwPayframe.deploy();
              })

            } else {
              this.loading = false;
              this.showSnackBar('Purchase could not progress. Please check credit card details.', 'error')
            }
          }
        }


      }

    },

    updatecarddetails() {
      var cardloadedimg = document.getElementById("cardloadedimg");
      cardloadedimg.style.display = 'block';
      this.modal = true;
      this.show_submit_button = false;
      const data = {
        plan_id: 1,
        summ: 10,
      }
      document.getElementById("cardData").innerHTML = "";

      this.buttonlabel = "Update";
      this.modaltitle = "Update Your Credit Card Details";
      var button = document.getElementById("submitButton");
      let payframeScript = document.createElement('script');
      payframeScript.setAttribute('src', MW_TEST_MODE ? 'https://securetest.merchantwarrior.com/payframe/payframe.js' : 'https://secure.merchantwarrior.com/payframe/payframe.js');
      document.head.appendChild(payframeScript);
      this.$store.dispatch('subscription/payments/ACCESS_TOKEN', data).then((data) => {
        this.$auth.user(new Parent(data))

        add_card_dialog(data.access_token);
        //this.show_submit_button = true;
      });

      var add_card_dialog = (access_token) => {
        let checkInterval = setInterval(function () {
          let payframeScriptIsReady = false;
          if (typeof payframe !== 'undefined') {
            payframeScriptIsReady = true;
            clearInterval(checkInterval);
            setShowSubmitButton(false);
            var method = 'addCard'; // change this to getPayframeToken for payment payframe
            var threeDS = true; // this will only work with the getPayframeToken method
            var style = {
              fontFamily: 'Open Sans, sans-serif',
              fontSrc: ['https://fonts.googleapis.com/css?family=Open+Sans'],
            };
            // var accessToken = access_token;

            var accessToken = access_token;
            // alert(access_token);

            var submitURL = MW_TEST_MODE ? 'https://base.merchantwarrior.com/payframe/' : 'https://api.merchantwarrior.com/payframe/';

            var payframeObject = {
              accessToken: accessToken,
              payframeDivId: 'cardData',
              src: MW_TEST_MODE ? 'https://securetest.merchantwarrior.com/payframe/' : 'https://secure.merchantwarrior.com/payframe/',
              submitUrl: submitURL,
              style: style,
              method: method,
            };
            this.mwPayframe = new payframe(payframeObject);
            this.mwPayframe.deploy();
            mwPayframe.mwCallback = function () {
              // alert('1');
              //Example of success and error scenarios below
              if (threeDS) {
                //alert('1');
                processResponseEvent_recurring(method, arguments, tdsCheck);
              } else {
                //alert('2');
                processResponseEvent_recurring(method, arguments);
              }
            };



            this.mwPayframe.loading = function () {
              var mwIframe = document.getElementById("mwIframe");
              var cardDiv = document.getElementById("cardData");
              //alert();
              setShowSubmitButton(false);
              // Hide the payframe during load operations
              mwIframe.style.visibility = 'hidden';

              // Assign the parent div the same dimensions as the payframe
              var height = mwIframe.height;
              var width = mwIframe.width;

              cardDiv.style.height = height;
              cardDiv.style.width = width;

              // Place a loading animation in the center of the payframe
              cardDiv.style.background = "url('https://securetest.merchantwarrior.com/inc/image/loading_gif.gif') center center no-repeat";
            };

            this.mwPayframe.loaded = function () {
              //button.style.visibility = "visible";
              var mwIframe = document.getElementById("mwIframe");
              //alert('loaded');

              var cardDiv = document.getElementById("cardData");
              var cardloadedimg = document.getElementById("cardloadedimg");
              // Remove the loading animation after the payframe has completed its operations and display the payframe
              cardDiv.style.visibility = 'none';
              cardloadedimg.style.display = 'none';
              if (mwIframe) {
                mwIframe.style.visibility = 'visible';

                setShowSubmitButton(true);

                console.log('Loaded');
                //alert('loaded');
              }
            }
          }
        }, 500);
        var setShowSubmitButton = (value) => {
          this.show_submit_button = value;

        }
        var processResponseEvent_recurring = (method, responseapi, tdsCheck) => {
          var responseCode = mwPayframe.responseCode;
          var responseMessage = mwPayframe.responseMessage;

          if (method == 'addCard') {

            var cardID = responseapi[0];
            var payframeToken = responseapi[1];
            var payframeKey = responseapi[2];
            //console.log(responseapi);
            if (cardID && cardID != 'NO_TOKEN') {
              const data = {
                card_id: cardID
              }
              this.$store.dispatch('subscription/payments/UPDATE_CARD', data).then((data) => {
                this.$auth.user(new Parent(data))
                this.modal = false
                this.loading = false
                if (data.cardID) {
                  this.showSnackBar('Card has has been successfully', 'success');
                  // update card details
                  var cardlast = data.cardNumberLast;
                  var cardExpiryMonth = data.cardExpiryMonth;
                  var cardExpiryYear = data.cardExpiryYear;
                  this.carddetails = 'xxxx-xxxx-xxxx-' + cardlast + '       ' + cardExpiryMonth + '/' + cardExpiryYear;
                  document.getElementById("cardnumber").innerHTML = 'xxxx-xxxx-xxxx-' + cardlast;
                  document.getElementById("cardexpiry").innerHTML = cardExpiryMonth + '/' + cardExpiryYear;

                } else {
                  this.showSnackBar('Technical issue facing to update the card details...Please try later', 'error');
                }

                setLoading(false);
                mwPayframe.reset();
                mwPayframe.deploy();
              })

              setLoading(false);
              mwPayframe.reset();
              mwPayframe.deploy();


            } else {
              this.loading = false;
              this.showSnackBar('Purchase could not progress. Please check credit card details.', 'error')
            }
          }
        }


      }


    },
    renewsubscription_cardsave(planid) {
      var cardloadedimg = document.getElementById("cardloadedimg");
      cardloadedimg.style.display = 'block';
      this.modal = true;
      this.show_submit_button = false;
      const data = {
        plan_id: planid,
        summ: 49,
      }
      document.getElementById("cardData").innerHTML = "";

      var button = document.getElementById("submitButton");
      let payframeScript = document.createElement('script');
      payframeScript.setAttribute('src', MW_TEST_MODE ? 'https://securetest.merchantwarrior.com/payframe/payframe.js' : 'https://secure.merchantwarrior.com/payframe/payframe.js');
      document.head.appendChild(payframeScript);
      this.$store.dispatch('subscription/payments/ACCESS_TOKEN', data).then((data) => {
        this.$auth.user(new Parent(data))

        add_card_dialog(data.access_token);
        //this.show_submit_button = true;
      });

      var add_card_dialog = (access_token) => {
        let checkInterval = setInterval(function () {
          let payframeScriptIsReady = false;
          if (typeof payframe !== 'undefined') {
            payframeScriptIsReady = true;
            clearInterval(checkInterval);
            setShowSubmitButton(false);
            var method = 'addCard'; // change this to getPayframeToken for payment payframe
            var threeDS = true; // this will only work with the getPayframeToken method
            var style = {
              fontFamily: 'Open Sans, sans-serif',
              fontSrc: ['https://fonts.googleapis.com/css?family=Open+Sans'],
            };
            // var accessToken = access_token;

            var accessToken = access_token;
            // alert(access_token);

            var submitURL = MW_TEST_MODE ? 'https://base.merchantwarrior.com/payframe/' : 'https://api.merchantwarrior.com/payframe/';

            var payframeObject = {
              accessToken: accessToken,
              payframeDivId: 'cardData',
              src: MW_TEST_MODE ? 'https://securetest.merchantwarrior.com/payframe/' : 'https://secure.merchantwarrior.com/payframe/',
              submitUrl: submitURL,
              style: style,
              method: method,
            };
            this.mwPayframe = new payframe(payframeObject);
            this.mwPayframe.deploy();
            mwPayframe.mwCallback = function () {
              // alert('1');
              //Example of success and error scenarios below
              if (threeDS) {
                //alert('1');
                processResponseEvent_recurring(method, arguments, tdsCheck);
              } else {
                //alert('2');
                processResponseEvent_recurring(method, arguments);
              }
            };



            this.mwPayframe.loading = function () {
              var mwIframe = document.getElementById("mwIframe");
              var cardDiv = document.getElementById("cardData");
              //alert();
              setShowSubmitButton(false);
              // Hide the payframe during load operations
              mwIframe.style.visibility = 'hidden';

              // Assign the parent div the same dimensions as the payframe
              var height = mwIframe.height;
              var width = mwIframe.width;

              cardDiv.style.height = height;
              cardDiv.style.width = width;

              // Place a loading animation in the center of the payframe
              cardDiv.style.background = "url('https://securetest.merchantwarrior.com/inc/image/loading_gif.gif') center center no-repeat";
            };

            this.mwPayframe.loaded = function () {
              //button.style.visibility = "visible";
              var mwIframe = document.getElementById("mwIframe");
              //alert('loaded');

              var cardDiv = document.getElementById("cardData");
              var cardloadedimg = document.getElementById("cardloadedimg");
              // Remove the loading animation after the payframe has completed its operations and display the payframe
              cardDiv.style.visibility = 'none';
              cardloadedimg.style.display = 'none';
              if (mwIframe) {
                mwIframe.style.visibility = 'visible';
                setShowSubmitButton(true);
                console.log('Loaded');
                //alert('loaded');
              }
            }
          }
        }, 500);
        var setShowSubmitButton = (value) => {
          this.show_submit_button = value;
        }
        var processResponseEvent_recurring = (method, responseapi, tdsCheck) => {
          var responseCode = mwPayframe.responseCode;
          var responseMessage = mwPayframe.responseMessage;

          if (method == 'addCard') {
            var cardID = responseapi[0];
            var payframeToken = responseapi[1];
            var payframeKey = responseapi[2];
            console.log(responseapi);
            if (cardID && cardID != 'NO_TOKEN') {
              const data = {
                plan_id: 1,
                summ: '49',
                card_id: cardID
              }


              this.$store.dispatch('subscription/payments/CREDIT_CARD', data).then((data) => {
                if (data.status) {
                  //this.$auth.user(new Parent(data))
                  this.modal = false
                  this.loading = false
                  this.showSnackBar('Purchase has been successfully', 'success')
                  this.invoice_table_reload++
                  this.show_monthly_subsr = false;
                  this.recurring_plan_information_additional = 'You have subscribed to the Monthly plan which will commence from ' + moment(this.$auth.user().subscription.ends_at).format('DD/MM/YYYY');
                  setTimeout(
                    this.$router.go()
                    , 10000);
                } else {
                  this.showSnackBar(data.message, 'error')
                  this.loading = false
                }

                setLoading(false);
                mwPayframe.reset();
                mwPayframe.deploy();
              })

            }
          }
        }


      }

    },
    renewsubscription() {
      let plans = this.$store.getters['subscription/plans']
      var cardloadedimg = document.getElementById("cardloadedimg");
      cardloadedimg.style.display = 'block';
      this.modal = true,
        this.loading = false
      this.show_submit_button = false;
      document.getElementById("cardData").innerHTML = "";
      let payframeScript = document.createElement('script');
      payframeScript.setAttribute('src', MW_TEST_MODE ? 'https://securetest.merchantwarrior.com/payframe/payframe.js' : 'https://secure.merchantwarrior.com/payframe/payframe.js');
      document.head.appendChild(payframeScript);

      let payframeScriptIsReady = false;

      let checkInterval = setInterval(function () {

        if (typeof payframe !== 'undefined') {
          payframeScriptIsReady = true;
          clearInterval(checkInterval);
          var merchantUUID = MW_MERCHANT_UUID;
          var apiKey = MW_API_KEY;
          var src = MW_TEST_MODE ? 'https://securetest.merchantwarrior.com/payframe/' : 'https://secure.merchantwarrior.com/payframe/';
          var submitUrl = MW_TEST_MODE ? 'https://base.merchantwarrior.com/payframe/' : 'https://api.merchantwarrior.com/payframe/';
          var threeDS = true;
          var style = {
            backgroundColor: '#ffffff',
            textColor: '#000000de',
            border: '1px solid #d8d8d8',
            fontFamily: 'Arial',
            errorTextColor: 'red',
            errorBorderColor: 'red',
            fontSize: '16px',
            width: '450px',
            cardTypeDisplay: 'right',
            padding: '5px',
            fieldHeight: '50px',
          };

          var acceptedCardTypes = "Visa, Diners Club, Mastercard";
          //Instantiate the payframe
          //If not set, the method parameter defaults to getPayframeToken
          this.mwPayframe = new payframe(merchantUUID, apiKey, 'cardData', src, submitUrl, style, acceptedCardTypes);

          //Set mwCallback
          this.mwPayframe.deploy();

          //3DS
          if (threeDS) {
            //Set tdsStyle properties
            var tdsStyle = {
              width: '400px',
            };

            //Instantiate tdsCheck object
            var tdsCheck = new window.tdsCheck(merchantUUID, apiKey, 'cardData', submitUrl, tdsStyle);
            tdsCheck.link(mwPayframe);
          }

          //Payframe callback
          this.mwPayframe.mwCallback = (tokenStatus, payframeToken, payframeKey) => {
            if (threeDS) {
              var transactionCurrency = 'AUD';
              var transactionAmount = (Math.round(getCurrentPlanPrice() * 100) / 100).toFixed(2);
              var transactionProduct = getInvoicePlanId();
              //Run 3DS check on payment details.
              //If you don't want to check 3DS, you can submit the transaction details directly

              tdsCheck.checkTDS(payframeToken, payframeKey, transactionAmount, transactionCurrency, transactionProduct);

              tdsCheck.loaded = function () {
                setShowSubmitButton(false);
              };

              tdsCheck.mwCallback = function (liabilityShifted, threeDSToken) {

                if (liabilityShifted) {
                  processResponseEvent(tokenStatus, payframeToken, payframeKey, threeDSToken);
                  //  alert('3DS transaction checked');
                } else {
                  // alert('3DS transaction failed');
                  //If liability wasn't shifted, close the 3DS verification window and re-deploy the payframe for the customer to enter a different card
                  mwPayframe.deploy();
                  setLoading(false);
                }

                setShowSubmitButton(true);
                tdsCheck.destroy();
              };

            } else {

              processResponseEvent(tokenStatus, payframeToken, payframeKey);
            }
            // processResponseEvent(tokenStatus, payframeToken, payframeKey);
          };


          this.mwPayframe.loaded = function () {
            var mwIframe = document.getElementById("mwIframe");
            //alert('loaded');

            var cardDiv = document.getElementById("cardData");

            // Remove the loading animation after the payframe has completed its operations and display the payframe
            cardDiv.style.visibility = 'none';
            cardloadedimg.style.display = 'none';
            if (mwIframe) {
              mwIframe.style.visibility = 'visible';

              setShowSubmitButton(true);

              console.log('Loaded');
              //alert('loaded');
            }
          };
        }

        return payframeScriptIsReady;
      }, 500);
      var getCurrentPlanPrice = () => {
        return this.currentPlan.price;
      }

      var getInvoicePlanId = () => {
        return this.invoice.plan_id;
      }

      var setLoading = (value) => {
        this.loading = value;
      }

      var setShowSubmitButton = (value) => {
        this.show_submit_button = value;
      }

      var processResponseEvent = (tokenStatus, payframeToken, payframeKey, threeDSToken) => {

        const data = {
          plan_id: this.invoice.plan_id,
          summ: this.currentPlan.price,
          payframe_token: payframeToken,
          payframe_key: payframeKey
        }
        // alert(payframeToken);
        // alert(payframeKey);
        // alert(threeDSToken);
        // return false;


        if (threeDSToken) {
          data.three_ds_token = threeDSToken
        }
        this.$store.dispatch('subscription/payments/CREDIT_CARD', data)
          .then((data) => {
            if (data.status) {
              this.$auth.user(new Parent(data))
              this.modal = false
              this.loading = false
              this.showSnackBar('Purchase has been successfully... Reloading page to update information', 'success')
              this.invoice_table_reload++
              setTimeout(
                this.$router.go()
                , 10000);

            } else {
              this.showSnackBar(data.message, 'error')
              this.loading = false
            }

            setLoading(false);
            mwPayframe.reset();
            mwPayframe.deploy();
          })
      }

    },
  }
}
</script>

<style lang="stylus" scoped>
.cancel-membership-btn {
  margin: 16px auto 0 auto; /* top margin + auto for left & right */
  background-color: #ff4d4f;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  display: block; /* ensure block-level for auto margin to work */
  text-align: center;
}


.cancel-membership-btn:hover {
  background-color: #d9363e;
}


._box
  height 150px !important

.infoprice
  margin 15px 0    

.cancelsubs
  text-decoration underline
  cursor pointer

._with-desc
  margin 25px 0px 0 0 
  font-size 14px
  padding 0 10px

.textinstruct
  margin: 15px 0
  display inline-block
#cardexpiry
  margin-left:35px;
.updatecardbtn
  margin-top 20px
._status-box
    color var(--blue)
    border 1px solid
    border-color  var(--grey_3) transparent
    padding 44px 0
    margin-bottom 34px
    > p
        margin-bottom 0
    .svg-icon
        width 16px
        height 16px
        margin-right 6px
.v-btn--default
    min-width 100%

@media (min-width: 600px)
    
    ._plan
        padding-top 20px
    ._invoice-box
        margin-bottom 150px
        margin-top 40px
    .v-btn--default
        min-width 217px
    ._status-box
        .svg-icon
            width 20px
            height 20px
            margin-right 16px
</style>



// WEBPACK FOOTER //
// src/views/app/subscription/index.vue